module.exports = __webpack_public_path__ + "assets/front-loader.svg?7abb9164eca377be7c900fd8a4db2ede";